import { useState } from 'react';

export default function WhyChooseUs() {
  const [flippedCard, setFlippedCard] = useState<number | null>(null);

  const reasons = [
    {
      icon: 'fas fa-heart',
      title: 'Adult Care (18+)',
      subtitle: 'Quality Care',
      description:
        'Our staff understands the array of adult needs and possess the patience as well as the necessary skills to provide client-centered services.',
    },
    {
      icon: 'fas fa-hospital-alt',
      title: 'Personal Care',
      subtitle: 'At your service',
      description:
        'At Kali Kare Homecare, we take great pride in offering client optimal care and satisfaction. Our primary goal is to provide our clients with an environment to which they can rely on quality and compassionate personal care.',
    },
    {
      icon: 'fas fa-hand-holding-heart',
      title: 'Companion Care',
      subtitle: 'Lending a hand',
      description:
        'Our in-home companion care services are designed to make daily living more enjoyable and comfortable for our clients. Activities include engaging in friendly conversation, and accompanying clients to appointments or social outings.',
    },
    {
      icon: 'fas fa-medkit',
      title: 'Additional Services',
      subtitle: 'Helping on all fronts',
      description:
        'We utilize a best practice approach to provide services for the elderly. Understanding that no 2 situations are the same our care plans are customizable and also are offered via a la carte.',
    },
    {
      icon: 'fas fa-file-medical',
      title: 'Personal Care Assessments',
      subtitle: 'Tending to you',
      description:
        'Our team of experienced professionals will assess your needs upon intake. With the results of assessment we will develop a personalized plan tailored to your specific needs. Our care plans can be adjusted as need upon your request.',
    },
    {
      icon: 'fas fa-user-clock',
      title: 'Excellent Care 24/7',
      subtitle: 'Around the clock',
      description:
        'Our clients have access to excellent customer service 24/7 365. At Kali Kare our services go beyond just home care. We pride ourselves in providing comfort and companionship to your loved one.',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-orange-500">Why Choose Us</h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="relative h-80 cursor-pointer perspective-1000"
              onMouseEnter={() => setFlippedCard(index)}
              onMouseLeave={() => setFlippedCard(null)}
            >
              <div
                className={`relative w-full h-full transition-transform duration-500 transform-style-3d ${
                  flippedCard === index ? 'rotate-y-180' : ''
                }`}
              >
                <div className="absolute inset-0 backface-hidden bg-[#5C4F8A] rounded-2xl p-8 flex flex-col items-center justify-center text-center text-white shadow-xl">
                  <div className="w-16 h-16 flex items-center justify-center mb-6">
                    <i className={`${reason.icon} text-5xl text-orange-400`}></i>
                  </div>
                  <h3 className="text-xl font-bold mb-2">{reason.title}</h3>
                  <p className="text-sm text-purple-200">{reason.subtitle}</p>
                </div>

                <div className="absolute inset-0 backface-hidden bg-orange-500 rounded-2xl p-8 flex flex-col items-center justify-center text-center text-white shadow-xl rotate-y-180">
                  <p className="text-sm leading-relaxed mb-6">{reason.description}</p>
                  <button className="bg-white text-orange-600 px-6 py-2 rounded-lg text-xs font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer">
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .perspective-1000 {
          perspective: 1000px;
        }
        .transform-style-3d {
          transform-style: preserve-3d;
        }
        .backface-hidden {
          backface-visibility: hidden;
        }
        .rotate-y-180 {
          transform: rotateY(180deg);
        }
      `}</style>
    </section>
  );
}